import { z } from 'zod'

export const scenesSearchSchema = z.object({
  view: z.enum(['grid', 'list']).optional().catch('grid'),
  folder: z.string().optional().catch(undefined),
  space: z.enum(['workspace', 'org']).optional().catch(undefined),
})

export type ScenesSearchParams = z.infer<typeof scenesSearchSchema>
